// Currency denomination data
const CURRENCY_UNIT_VALUES = new Map<string, number[]>([
  ['CAD', [0.01, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['USD', [0.01, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['GBP', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50]],
  ['MXN', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['NZD', [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['AUD', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  [
    'EUR',
    [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500],
  ],
  ['PGK', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['ZAR', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['AED', [0.25, 0.5, 1, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['ALL', [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000]],
  ['ANG', [0.01, 0.05, 0.1, 0.25, 1, 2.5, 5, 10, 25, 50, 100]],
  [
    'ARS',
    [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000],
  ],
  ['AWG', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2.5, 5, 10, 25, 50, 100]],
  ['BBD', [0.01, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['BDT', [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['BGN', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['BHD', [0.005, 0.01, 0.025, 0.05, 0.1, 0.5, 1, 5, 10, 20]],
  ['BIF', [1, 5, 10, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['BMD', [0.01, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['BND', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 50, 100]],
  ['BOB', [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['BRL', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['BSD', [0.01, 0.05, 0.1, 0.15, 0.25, 1, 3, 5, 10, 20, 50, 100]],
  ['BTN', [0.05, 0.1, 0.2, 0.25, 1, 5, 10, 20, 50, 100, 500, 1000]],
  ['BWP', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  [
    'BYR',
    [
      1,
      2,
      5,
      10,
      20,
      50,
      100,
      500,
      1000,
      5000,
      10000,
      20000,
      50000,
      100000,
      200000,
    ],
  ],
  ['BZD', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['CHF', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 1000]],
  ['CLP', [1, 5, 10, 50, 100, 500, 1000, 2000, 5000, 10000, 20000]],
  ['CNY', [0.01, 0.05, 0.1, 0.5, 1, 5, 10, 20, 50, 100]],
  ['COP', [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]],
  ['CRC', [5, 10, 25, 50, 100, 500, 1000, 2000, 5000, 10000, 20000, 50000]],
  ['CUP', [0.01, 0.05, 0.2, 1, 3, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['CVE', [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000]],
  ['CZK', [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000]],
  ['DJF', [1, 2, 5, 10, 20, 50, 100, 250, 500, 1000, 2000, 5000, 10000]],
  ['DKK', [0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['DOP', [1, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 2000]],
  ['DZD', [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000]],
  ['ECS', [1, 5, 10, 20, 50, 100, 500, 1000, 5000, 10000, 20000, 50000]],
  ['EEK', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 25, 50, 100, 500]],
  ['EGP', [0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100, 200]],
  ['ERN', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100]],
  ['ETB', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 50, 100, 200]],
  ['FJD', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['FKP', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20]],
  [
    'GHC',
    [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000],
  ],
  ['GIP', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50]],
  ['GMD', [1, 5, 10, 20, 25, 50, 100, 200]],
  ['GNF', [1, 5, 10, 25, 50, 100, 500, 1000, 5000, 10000, 20000]],
  ['GTQ', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100, 200]],
  ['GYD', [1, 5, 10, 20, 100, 500, 1000, 5000, 10000]],
  ['HKD', [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 500, 1000]],
  ['HNL', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 500]],
  [
    'HRK',
    [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000],
  ],
  ['HTG', [5, 10, 20, 25, 50, 100, 250, 500, 1000]],
  ['HUF', [5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000]],
  [
    'IDR',
    [25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000],
  ],
  ['ILS', [0.01, 0.05, 0.1, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['INR', [1, 2, 5, 10, 20, 50, 100, 200, 500, 2000]],
  ['IQD', [25, 50, 100, 250, 500, 1000, 5000, 10000, 25000, 50000]],
  ['IRR', [50, 100, 250, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]],
  ['ISK', [1, 5, 10, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['JMD', [0.01, 0.05, 0.1, 0.25, 1, 5, 10, 20, 50, 100, 500, 1000, 5000]],
  ['JOD', [0.001, 0.005, 0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50]],
  ['JPY', [1, 5, 10, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['KES', [0.5, 1, 5, 10, 20, 40, 50, 100, 200, 500, 1000]],
  ['KHR', [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]],
  ['KMF', [1, 2, 5, 10, 25, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['KPW', [1, 5, 10, 50, 100, 200, 500, 1000, 2000, 5000]],
  ['KRW', [1, 5, 10, 50, 100, 500, 1000, 5000, 10000, 50000]],
  ['KWD', [0.001, 0.005, 0.01, 0.02, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20]],
  ['KYD', [0.01, 0.05, 0.1, 0.25, 1, 5, 10, 25, 40, 50, 100]],
  ['KZT', [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000]],
  [
    'LAK',
    [10, 20, 50, 100, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000],
  ],
  ['LBP', [25, 50, 100, 250, 500, 1000, 5000, 10000, 20000, 50000, 100000]],
  ['LKR', [1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 2000, 5000]],
  ['LRD', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100]],
  ['LSL', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  [
    'LTL',
    [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500],
  ],
  ['LVL', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 500]],
  ['LYD', [0.001, 0.005, 0.01, 0.02, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50]],
  ['MAD', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  [
    'MDL',
    [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000],
  ],
  ['MKD', [0.5, 1, 2, 5, 10, 50, 100, 500, 1000, 2000, 5000]],
  ['MMK', [1, 5, 10, 25, 50, 100, 200, 500, 1000, 5000, 10000]],
  ['MNT', [1, 5, 10, 20, 50, 100, 200, 500, 1000, 5000, 10000, 20000]],
  ['MOP', [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 500, 1000]],
  ['MRO', [1, 5, 10, 20, 100, 200, 500, 1000]],
  ['MTL', [0.01, 0.02, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20]],
  ['MUR', [1, 5, 20, 25, 50, 100, 200, 500, 1000, 2000]],
  ['MVR', [0.01, 0.02, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 500]],
  ['MWK', [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000]],
  ['MYR', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 5, 10, 20, 50, 100]],
  ['NAD', [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['NGN', [0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['NIO', [0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100, 200, 500]],
  ['NOK', [0.5, 1, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['NPR', [1, 2, 5, 10, 20, 25, 50, 100, 250, 500, 1000]],
  ['OMR', [0.005, 0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50]],
  ['PAB', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100]],
  ['PEN', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['PHP', [0.01, 0.05, 0.1, 0.25, 1, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['PKR', [1, 2, 5, 10, 20, 50, 100, 500, 1000, 5000]],
  [
    'PLN',
    [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500],
  ],
  ['PYG', [50, 100, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]],
  ['QAR', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 50, 100, 500]],
  ['RON', [0.01, 0.05, 0.1, 0.5, 1, 5, 10, 50, 100, 200, 500]],
  [
    'RUB',
    [0.01, 0.05, 0.1, 0.5, 1, 2, 5, 10, 50, 100, 200, 500, 1000, 2000, 5000],
  ],
  ['RWF', [1, 5, 10, 20, 50, 100, 500, 1000, 2000, 5000]],
  ['SAR', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500]],
  ['SBD', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['SCR', [0.01, 0.05, 0.1, 0.25, 1, 5, 10, 25, 50, 100, 500]],
  ['SDG', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['SEK', [0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000]],
  ['SGD', [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 50, 100, 1000, 10000]],
  ['SHP', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20]],
  ['SKK', [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 5000]],
  ['SLL', [10, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['SOS', [1, 5, 10, 20, 50, 100, 500, 1000]],
  ['SRD', [0.01, 0.05, 0.1, 0.25, 1, 2.5, 5, 10, 20, 50, 100]],
  ['STD', [100, 250, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]],
  ['SVC', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100, 200]],
  ['SYP', [1, 2, 5, 10, 25, 50, 100, 200, 500, 1000]],
  ['SZL', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]],
  ['THB', [0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 500, 1000]],
  ['TND', [0.005, 0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 5, 10, 20, 50]],
  ['TOP', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['TRY', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100, 200]],
  ['TTD', [0.01, 0.05, 0.1, 0.25, 0.5, 1, 5, 10, 20, 50, 100]],
  ['TWD', [0.5, 1, 5, 10, 50, 100, 200, 500, 1000, 2000]],
  ['TZS', [50, 100, 200, 500, 1000, 2000, 5000, 10000]],
  [
    'UAH',
    [
      0.01,
      0.02,
      0.05,
      0.1,
      0.25,
      0.5,
      1,
      2,
      5,
      10,
      20,
      50,
      100,
      200,
      500,
      1000,
    ],
  ],
  ['UGX', [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000]],
  ['UYU', [0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000]],
  ['VEF', [0.01, 0.05, 0.1, 0.125, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  [
    'VND',
    [200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000, 200000, 500000],
  ],
  ['VUV', [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]],
  ['WST', [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100]],
  ['XAF', [1, 2, 5, 10, 25, 50, 100, 500, 1000, 2000, 5000, 10000]],
  ['XCD', [0.01, 0.02, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['XCG', [0.01, 0.02, 0.05, 0.1, 0.25, 1, 2, 5, 10, 20, 50, 100]],
  ['XOF', [1, 5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000]],
  ['XPF', [1, 2, 5, 10, 20, 50, 100, 500, 1000, 5000, 10000]],
  ['YER', [1, 5, 10, 20, 50, 100, 200, 250, 500, 1000]],
  ['ZMK', [5, 10, 25, 50, 100, 500, 1000, 5000, 10000, 20000, 50000]],
  [
    'ZWD',
    [
      0.01,
      0.05,
      0.1,
      0.2,
      0.5,
      1,
      2,
      5,
      10,
      20,
      50,
      100,
      500,
      1000,
      5000,
      10000,
      20000,
      50000,
      100000,
    ],
  ],
])

// Fallback denominations
const FALLBACK_VALUES = [
  0.01,
  0.05,
  0.1,
  0.25,
  1.0,
  5.0,
  10.0,
  20.0,
  50.0,
  100.0,
]

// Export currency denominations (convert Map to object for backward compatibility)
export const CURRENCY_DENOMINATIONS: Record<string, number[]> = {
  // eslint-disable-next-line compat/compat
  ...Object.fromEntries(CURRENCY_UNIT_VALUES),
  FALLBACK: FALLBACK_VALUES,
}

// Utility function to get denominations for a currency (with fallback)
export function getCurrencyDenominations(currencyCode: string): number[] {
  return CURRENCY_DENOMINATIONS[currencyCode] || CURRENCY_DENOMINATIONS.FALLBACK
}
